module.exports = __webpack_public_path__ + "static/media/Intersection 15.c23cc965.png";